module.exports = __webpack_public_path__ + "static/media/roadside_assist.c1d9cd5f.svg";